import React, {useEffect, useState} from 'react';
import SearchBar from "../components/SearchBar";
import {useNavigate} from "react-router-dom";
import Slideshow from "../components/Slideshow";
import ProductGroups from "../components/ProductGroups";
import Products from "../components/Products";
import DiscountedProducts from "../components/DiscountedProducts";
import Brands from "../components/Brands";
import Navbar from "../../../layouts/Navbar";
import Alerts from "../components/Alerts";
import ProductGroupsSlide from "../components/ProductGroupsSlide";
import OrganizationPropertise from "../components/OrganizationPropertise";
import Stories from "../components/Stories";
import LoginHint from "../../../components/shared/LoginHint";
import NewProducts from "../components/NewProducts";
import ScrollToTopButton from "../../../components/shared/ScrollToTopButton";
import HelpSection from '../components/HelpSection';
import HideOnScroll from '../components/HideOnScroll';

const HomePage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const [hasToken, setHasToken] = useState(false);

    useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if (token) {

            if (window.localStorage.getItem("needRegistration") === '1') {
                navigate('/register');
            }
            setHasToken(true)
        } else {
            if (config.shopping_app_settings.need_login > 0) {
                navigate('/login');
            }
        }

    }, []);

    return (
        <div className='pt-md-4 bg-white'>

            <HideOnScroll direction="up">
                <div className="top-fixed">
                    <Alerts/>
                    <SearchBar/>
                </div>
            </HideOnScroll>

            <div style={{paddingTop: '60px'}}>
                <Slideshow/>
                {
                    config.shopping_app_settings.product_group_slide === "1" ?
                        <ProductGroupsSlide/>
                        :
                        <ProductGroups/>
                }
                <NewProducts/>
                <Stories/>

                <DiscountedProducts/>
                <Products/>
                <Brands/>

                <OrganizationPropertise/>
                {
                    !hasToken && <LoginHint/>
                }

                <HelpSection/>
            </div>


            <HideOnScroll direction="down">
                <Navbar/>
            </HideOnScroll>

        </div>
    );
};

export default HomePage;